<template>
  <div class="wrap">
    <div class="contents_wrap type2">
      <section>
        <div class="login_box">
          <div class="left">
            <div class="login_logo">
              <h1>AICC SaaS에 오신 것을 환영합니다.</h1>
              <span>서비스 관련 문의 주시면 빠른 시간안에 답변 드리겠습니다.</span>
              <span>aicc_saas@samsung.com</span>
              <br>
              <span>기존 사용자의 경우 고객사별 접속경로로 로그인해주세요.</span>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import '~assets/css/aicc/home.css';/* css 파일 내 home_footer class 스타일을 가져오기 위한 import  */

export default {
  name: 'Welcome',
  data() {
    return {
    };
  },
  mounted() {
    this.$store.commit('hideGnbMenu');
    this.$store.commit('showFooter'); // 로그인 전에도 footer 표시
  },
  methods: {
  },
};
</script>

<style scoped>
/* ======== container ========= */
.wrap {background-image: url('../../assets/images/aicc/bg_welcome.jpg'); background-repeat : no-repeat; background-size: cover; background-position: center center;}
.left {display: flex; justify-content: center; width:100%;}
.login_box {background-color: transparent;}
.login_box .login_logo {margin-left: 0;}
</style>
